import { render, staticRenderFns } from "./StudentReserveSave.vue?vue&type=template&id=0178b5e7&"
import script from "./StudentReserveSave.vue?vue&type=script&lang=js&"
export * from "./StudentReserveSave.vue?vue&type=script&lang=js&"
import style0 from "./StudentReserveSave.vue?vue&type=style&index=0&id=0178b5e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports